import React from 'react';

export const AppLinking: React.FC = () => <></>;
